import React, { useEffect, useRef, useState } from 'react';
import useScript from 'hooks/useScript';

declare global {
  interface Window {
    FitMix: {
      createWidget: (
        containerId: string,
        params: Record<string, unknown>,
        callback: () => void
      ) => FitMixInstance;
    };
  }
}

interface FitMixInstance {
  setFrame: (glassesId: string) => void;
  startVto: (mode: string) => void;
  destroy: () => void;
}

type VtoProps = {
  apiKey?: string;
  glassesId: string;
};

export default function FittingboxVTO({ apiKey, glassesId }: VtoProps): JSX.Element {
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(true);

  const fitmixInstanceRef = useRef<FitMixInstance | null>(null);

  // Load the FittingBox script
  useScript('https://vto-advanced-integration-api.fittingbox.com/index.js', false, () =>
    setLoaded(true)
  );

  useEffect(() => {
    if (loaded) {
      const params = {
        apiKey,
      };
      fitmixInstanceRef.current = window.FitMix.createWidget(
        'my-fitmix-container',
        params,
        function () {
          fitmixInstanceRef.current?.setFrame(glassesId);

          // Show the container
          const fitmix = document.getElementById('my-fitmix-container');
          if (fitmix) {
            fitmix.style.display = 'block';
          }
          // Start VTO automatically
          fitmixInstanceRef.current?.startVto('live');

          // Hide loading text
          setLoading(false);

          console.log('VTO module is ready and started.');
        }
      );
      return () => {
        if (fitmixInstanceRef.current && typeof fitmixInstanceRef.current.destroy === 'function') {
          fitmixInstanceRef.current.destroy();
        }
      };
    }
  }, [loaded, apiKey, glassesId]);

  return (
    <div className="w-full h-full flex items-center justify-center relative">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-10">
          <span className="text-lg font-semibold">Loading Virtual Try-On...</span>
        </div>
      )}
      <div
        id="my-fitmix-container"
        className="w-full h-full min-w-[300px] min-h-[300px]"
        style={{ display: 'none' }}
      />
    </div>
  );
}
